// Submit-time validation for the unit forms (create + details). Returns error
// CODES — the drawers map them to copy — so this stays free of React and i18n.

import { isCoords } from './radius';

export interface UnitErrors {
  name?: 'required';
  /** Create only — the details drawer never edits the parent. */
  parent?: 'required';
  coordinates?: 'invalid';
}

/** The slice of the unit draft the rules read. */
export interface UnitDraftFields {
  name: string;
  coordinates: string;
  /** The RESOLVED parent id ('' when none) — only checked with `parentRequired`. */
  parentId?: string;
}

interface UnitRuleOptions {
  parentRequired?: boolean;
}

export const validateUnitDraft = (
  { name, coordinates, parentId = '' }: UnitDraftFields,
  { parentRequired = false }: UnitRuleOptions = {},
): UnitErrors => {
  const errors: UnitErrors = {};
  if (!name.trim()) errors.name = 'required';
  if (parentRequired && !parentId) errors.parent = 'required';
  // Coordinates are optional; when given they must be an in-range "lat, lng".
  if (coordinates.trim() && !isCoords(coordinates)) errors.coordinates = 'invalid';
  return errors;
};

export const hasErrors = (errors: UnitErrors): boolean => Object.keys(errors).length > 0;
